import React from 'react';

import {
  forwardRef,
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
  TypographyProps,
} from '@chakra-ui/react';

export type LinkProps = Omit<
  ChakraLinkProps,
  Exclude<keyof TypographyProps, 'textAlign' | 'fontWeight'>
>;

export const Link = forwardRef<LinkProps, 'a'>(
  ({ isExternal, children, href, ...chakraLinkProps }: LinkProps, ref) => {
    if (isExternal) {
      // If it's an external link, render a regular ChakraLink with an anchor tag
      return (
        <ChakraLink ref={ref} href={href || ''} isExternal {...chakraLinkProps}>
          {children}
        </ChakraLink>
      );
    }

    // If it's an internal link, use NextLink
    // TODO: RP - Reinstate NextLink to be used here
    return (
      <ChakraLink ref={ref} href={href || ''} {...chakraLinkProps}>
        {children}
      </ChakraLink>
    );
  }
);
